import React, { useCallback, useEffect, useRef, useState } from 'react';
import PageWrapper from '../components/layout/PageWrapper';
import { useTranslation } from 'react-i18next';
import Header from '../components/layout/Header';
import RoundAddButton from '../UI/buttons/RoundAddButton';
import AdminUserAdd from '../components/admin/AdminUserAdd';
import styled from 'styled-components';
import { Recruiter } from '../types';
import { useHistory } from 'react-router-dom';
import { getUrlString } from '../constants/queryParams';
import RecruiterListFilter from '../components/recruiter/RecruiterListFilter';
import RecruiterList from '../components/recruiter/RecruiterList';
import { getRecruiterList } from '../api/recruiter';
import Loader from '../UI/Loader';
import ReactGa from 'react-ga4';

const NoResultText = styled.p`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.33;
  letter-spacing: 0.96px;
  text-align: center;
  color: #061c2e;
  padding: 1rem;
`;
const Recruiters = () => {
  const [loading, setLoading] = useState(true);
  const [addUser, setAddUser] = useState(false);
  const [recruiters, setRecruiters] = useState<Recruiter[]>([]);

  const [next, setNext] = useState<string | null>(null);
  const loader = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const [t] = useTranslation();
  const params = new URLSearchParams(history.location.search);
  const company_name = params.get('company_name');
  const location = params.get('location');
  const domain = params.get('domain');
  const contact_name = params.get('contact_name');

  useEffect(() => {
    const query = getUrlString({
      company_name,
      location,
      contact_name,
      domain,
    });
    getRecruiterList(query && `?${query}`).then((res) => {
      setLoading(false);
      setRecruiters(res.data.results);
      setNext(res.data.pagination.next);
    });
  }, [company_name, domain, contact_name, location]);
  const handleObserver = useCallback(
    (entities: any) => {
      const cursor = `${
        history.location.search
          ? history.location.search + '&cursor=' + next
          : '?cursor=' + next
      }`;
      const target = entities[0];
      if (target.isIntersecting && next) {
        getRecruiterList(cursor).then((res) => {
          setRecruiters((prevState) => [...prevState, ...res.data.results]);
          setNext(res.data.pagination.next);
        });
      }
    },
    [next, history.location.search],
  );
  useEffect(() => {
    const current = loader.current;
    let options = {
      root: null,
      rootMargin: '0px 0px 300px 0px',
      threshold: 1.0,
    };
    const observer = new IntersectionObserver(handleObserver, options);

    if (!next) {
      observer.disconnect();
    } else {
      if (loader && current) {
        observer.observe((current as unknown) as Element);
      }
    }
    return () => observer.unobserve((current as unknown) as Element);
  }, [next, handleObserver]);
  const addClient = () => {
    setAddUser(true);
  };
  useEffect(() => {
    ReactGa.pageview('/recruiters');
  }, []);
  return (
    <PageWrapper>
      <Header title={t('RECRUITER_TITLE')}></Header>
      <RecruiterListFilter />
      <Loader spinning={loading}>
        {!loading && !recruiters.length ? (
          <NoResultText>{t('NO_RESULT')}</NoResultText>
        ) : (
          <RecruiterList recruiters={recruiters} />
        )}
        <div className="loader" ref={loader} />
      </Loader>
      <RoundAddButton onClick={() => addClient()} />
      <AdminUserAdd visible={addUser} setVisible={setAddUser} />
    </PageWrapper>
  );
};

export default Recruiters;
